// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/value_tone.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file chalk/artifacts/v1/value_tone.proto.
 */
export const file_chalk_artifacts_v1_value_tone: GenFile = /*@__PURE__*/
  fileDesc("CiNjaGFsay9hcnRpZmFjdHMvdjEvdmFsdWVfdG9uZS5wcm90bxISY2hhbGsuYXJ0aWZhY3RzLnYxKsMBCglWYWx1ZVRvbmUSGgoWVkFMVUVfVE9ORV9VTlNQRUNJRklFRBAAEhYKElZBTFVFX1RPTkVfTkVVVFJBTBABEhQKEFZBTFVFX1RPTkVfR1JFRU4QAhITCg9WQUxVRV9UT05FX0JMVUUQAxIVChFWQUxVRV9UT05FX1lFTExPVxAEEhUKEVZBTFVFX1RPTkVfT1JBTkdFEAUSEgoOVkFMVUVfVE9ORV9SRUQQBhIVChFWQUxVRV9UT05FX1BVUlBMRRAHYgZwcm90bzM");

/**
 * A tone from the reserved status palette. An enum, not a hex, so the light/dark steps stay client-side.
 *
 * @generated from enum chalk.artifacts.v1.ValueTone
 */
export enum ValueTone {
  /**
   * @generated from enum value: VALUE_TONE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VALUE_TONE_NEUTRAL = 1;
   */
  NEUTRAL = 1,

  /**
   * @generated from enum value: VALUE_TONE_GREEN = 2;
   */
  GREEN = 2,

  /**
   * @generated from enum value: VALUE_TONE_BLUE = 3;
   */
  BLUE = 3,

  /**
   * @generated from enum value: VALUE_TONE_YELLOW = 4;
   */
  YELLOW = 4,

  /**
   * @generated from enum value: VALUE_TONE_ORANGE = 5;
   */
  ORANGE = 5,

  /**
   * @generated from enum value: VALUE_TONE_RED = 6;
   */
  RED = 6,

  /**
   * @generated from enum value: VALUE_TONE_PURPLE = 7;
   */
  PURPLE = 7,
}

/**
 * Describes the enum chalk.artifacts.v1.ValueTone.
 */
export const ValueToneSchema: GenEnum<ValueTone> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_value_tone, 0);

